
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import StructuredData from './components/StructuredData';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Attachment from './pages/Attachment';
import Pricing from './pages/Pricing';
import Blog from './pages/Blog';
import BlogPost1 from './pages/BlogPost1';
import BlogPost2 from './pages/BlogPost2';
import CoimbatoreLanding from './pages/CoimbatoreLanding';
import Contact from './pages/Contact';
import Booking from './pages/Booking';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Refunds from './pages/Refunds';

function App() {
  return (
    <Router>
      <div className="App">
        <StructuredData />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/attachment" element={<Attachment />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/how-to-choose-mini-truck" element={<BlogPost1 />} />
          <Route path="/blog/mini-truck-booking-coimbatore" element={<CoimbatoreLanding />} />
          <Route path="/blog/mini-truck-booking-challenges-coimbatore" element={<BlogPost2 />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refunds" element={<Refunds />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
